import Vue from 'vue';
import '@/styles/theme.scss';
import VueObserveVisibility from 'vue-observe-visibility';
import store from '@/store/store';
import App from './App.vue';
import router from './router/routing';
import vuetify from './plugins/vuetify';

Vue.use(VueObserveVisibility);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
